// This file is auto-generated by typhoon/scripts/export_js_enums.py

export enum TrackingEvents {
    TemplateSearchEngagementTracking = 'template_search_engagement_tracking',
    ClickTracking = 'click_tracking',
    ContentLoadTracking = 'content_load_tracking',
    ExperimentAssignmentTracking = 'experiment_assignment_tracking',
    CfUpsellTracking = 'cf_upsell_tracking',
}
